export enum UserImageSizes {
  Small = 'small',
  Medium = 'medium',
  Big = 'big',
  Landscape_big = 'landscape_big',
  Origin = 'origin',
}
